(function () {
  'use strict';

  const API_PATH = '/apps/fh-bobbel/member-lab/insider';
  const HANDLE = /^(?=.{1,200}$)[a-z0-9]+(?:-[a-z0-9]+)*$/;
  const HISTORY_KEY = 'fhMemberLabInsider';
  const CURSOR = /^[A-Za-z0-9_-]{1,512}$/;
  const ISO_TIMESTAMP = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,9})?(?:Z|[+-]\d{2}:\d{2})$/;
  const ARTICLE_FRAME_MIN_HEIGHT = 1;
  const ARTICLE_FRAME_MAX_HEIGHT = 200000;

  function copy(content, key, fallback) {
    return (content.dataset && content.dataset[key]) || fallback;
  }

  function validDate(value) {
    return typeof value === 'string' && ISO_TIMESTAMP.test(value) && !Number.isNaN(new Date(value).getTime());
  }

  function validImage(value) {
    if (value === null) return true;
    if (!value || typeof value !== 'object' || typeof value.url !== 'string') return false;
    try {
      const url = new URL(value.url);
      return url.protocol === 'https:' && url.hostname === 'cdn.shopify.com'
        && url.username === '' && url.password === '' && url.port === '' && url.hash === ''
        && (value.altText === null || (typeof value.altText === 'string' && value.altText.length <= 2000));
    } catch {
      return false;
    }
  }

  function validPost(value, withBody) {
    const hasSafeBody = value && Object.prototype.hasOwnProperty.call(value, 'bodySafeHtml');
    return value && typeof value === 'object'
      && typeof value.handle === 'string' && HANDLE.test(value.handle)
      && typeof value.title === 'string' && value.title.length > 0 && value.title.length <= 1000
      && validDate(value.createdAt)
      && (value.updatedAt === null || validDate(value.updatedAt))
      && validImage(value.image)
      && (!withBody || (typeof value.bodyHtml === 'string' && value.bodyHtml.length <= 100000
        && (!hasSafeBody || (typeof value.bodySafeHtml === 'string' && value.bodySafeHtml.length <= 100000))));
  }

  function validList(value) {
    return value && typeof value === 'object' && value.version === 1
      && Array.isArray(value.posts) && value.posts.length <= 20
      && (value.nextCursor === null || (typeof value.nextCursor === 'string' && CURSOR.test(value.nextCursor)))
      && value.posts.every(function (post) {
        return validPost(post, false)
          && !Object.prototype.hasOwnProperty.call(post, 'bodyHtml')
          && !Object.prototype.hasOwnProperty.call(post, 'bodySafeHtml');
      });
  }

  function validDetail(value) {
    return value && typeof value === 'object' && value.version === 1 && validPost(value.post, true);
  }

  function status(content, message) {
    const node = content.querySelector('[data-member-lab-insider-status]');
    if (node) node.textContent = message;
  }

  function formatDate(value) {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString();
  }

  function imageFor(post) {
    if (!post.image) return null;
    const image = document.createElement('img');
    image.className = 'fh-member-lab__insider-image';
    image.src = post.image.url;
    image.alt = post.image.altText || '';
    image.loading = 'lazy';
    return image;
  }

  function plainTextFromHtml(value) {
    const withoutExecutableBlocks = value.replace(/<\s*(script|style|template|noscript|iframe|object|embed)\b[^>]*>[\s\S]*?<\s*\/\s*\1\s*>/gi, '');
    return withoutExecutableBlocks.replace(/<[^>]*>/g, '').replace(/&(amp|lt|gt|quot|#39|#x27);/gi, function (_, entity) {
      return { amp: '&', lt: '<', gt: '>', quot: '"', '#39': "'", '#x27': "'" }[entity.toLowerCase()];
    });
  }

  function escapeHtml(value) {
    return value.replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function safeArticleDocument(bodyHtml, bodySafeHtml) {
    const body = typeof bodySafeHtml === 'string'
      ? bodySafeHtml
      : '<pre class="fh-member-news-plain">' + escapeHtml(plainTextFromHtml(bodyHtml)) + '</pre>';
    return '<!doctype html><html><head><meta charset="utf-8"><meta name="referrer" content="no-referrer"><meta http-equiv="Content-Security-Policy" content="default-src \'none\'; base-uri \'none\'; form-action \'none\'; frame-ancestors \'none\'; script-src \'none\'; object-src \'none\'; media-src \'none\'; img-src https://cdn.shopify.com; style-src \'unsafe-inline\'"><style>*{box-sizing:border-box}html,body{max-width:100%;overflow-x:hidden;overflow-y:hidden;background:transparent}body{margin:0;color:#2d241c;font:16px/1.55 system-ui,sans-serif;overflow-wrap:anywhere}p,h2,h3,h4,h5,h6,ul,ol,blockquote,pre{max-width:76ch}p,h2,h3,h4,h5,h6,ul,ol,blockquote,pre,figure{margin:0 0 1em}h2,h3,h4,h5,h6{line-height:1.25}ul,ol{padding-left:1.5em}blockquote{border-left:3px solid #c9b9a8;padding-left:1em}pre{overflow-x:auto;white-space:pre-wrap}code{font-family:ui-monospace,SFMono-Regular,Consolas,monospace}figure{max-width:100%;margin-block:1.25em}figcaption{font-size:.875em;color:#66584b}img{display:block;max-width:100%;height:auto;border-radius:12px}.fh-member-news-plain{font:inherit}</style></head><body>' + body + '</body></html>';
  }

  function cleanupArticleFrameAutoHeight(content) {
    if (typeof content._memberLabInsiderFrameCleanup === 'function') {
      content._memberLabInsiderFrameCleanup();
    }
    content._memberLabInsiderFrameCleanup = null;
  }

  function setupArticleFrameAutoHeight(frame) {
    let active = true;
    let animationFrame = null;
    let allowShrink = true;
    let observer = null;
    let observedWidth = -1;
    let bodyWaitFrames = 10;

    function measure() {
      animationFrame = null;
      if (!active) return;
      try {
        const frameDocument = frame.contentDocument;
        const root = frameDocument && frameDocument.documentElement;
        const body = frameDocument && frameDocument.body;
        if (!root || !body) {
          if (bodyWaitFrames > 0) {
            bodyWaitFrames -= 1;
            schedule(true);
          }
          return;
        }
        if (allowShrink) frame.style.height = `${ARTICLE_FRAME_MIN_HEIGHT}px`;
        allowShrink = false;
        const heights = [root.scrollHeight, body.scrollHeight, root.offsetHeight, body.offsetHeight]
          .filter(function (height) { return Number.isFinite(height) && height > 0; });
        if (heights.length === 0) return;
        const height = Math.min(ARTICLE_FRAME_MAX_HEIGHT, Math.max(ARTICLE_FRAME_MIN_HEIGHT, Math.ceil(Math.max(...heights))));
        frame.style.height = `${height}px`;
      } catch {
        // Keep the tiny CSS fallback if the frame cannot be measured.
      }
    }

    function schedule(shrink) {
      if (!active) return;
      allowShrink = allowShrink || shrink === true;
      if (animationFrame !== null) return;
      animationFrame = window.requestAnimationFrame(measure);
    }

    function clearObservedContent() {
      if (observer) observer.disconnect();
      observer = null;
    }

    function observeContent() {
      clearObservedContent();
      let frameDocument;
      try {
        frameDocument = frame.contentDocument;
      } catch {
        schedule(true);
        return;
      }
      const root = frameDocument && frameDocument.documentElement;
      const body = frameDocument && frameDocument.body;
      if (!root || !body) {
        schedule(true);
        return;
      }
      bodyWaitFrames = 10;
      schedule(true);
      if (typeof window.ResizeObserver === 'function') {
        observer = new window.ResizeObserver(function (entries) {
          let widthChanged = false;
          entries.forEach(function (entry) {
            if (entry.target !== frame) return;
            const width = entry.contentRect && entry.contentRect.width;
            if (Number.isFinite(width) && width !== observedWidth) {
              observedWidth = width;
              widthChanged = true;
            }
          });
          schedule(widthChanged);
        });
        observer.observe(root);
        if (body !== root) observer.observe(body);
        observer.observe(frame);
      }
    }

    const onLoad = function () { observeContent(); };
    const onWindowResize = function () { schedule(true); };
    frame.addEventListener('load', onLoad);
    window.addEventListener('resize', onWindowResize);
    schedule(true);

    return function cleanup() {
      if (!active) return;
      active = false;
      clearObservedContent();
      frame.removeEventListener('load', onLoad);
      window.removeEventListener('resize', onWindowResize);
      if (animationFrame !== null && typeof window.cancelAnimationFrame === 'function') {
        window.cancelAnimationFrame(animationFrame);
      }
      animationFrame = null;
    };
  }

  async function getJson(path) {
    const response = await fetch(path, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
    });
    if (!response.ok) throw new Error('member_news_unavailable');
    return response.json();
  }

  function articleHandle() {
    return new URL(window.location.href).searchParams.get('insider');
  }

  function pageUrl(handle) {
    const url = new URL(window.location.href);
    if (handle === null) url.searchParams.delete('insider');
    else url.searchParams.set('insider', handle);
    return url.toString();
  }

  function historyState(kind, listContext, enteredFromList) {
    const previous = window.history.state;
    const state = previous && typeof previous === 'object' && !Array.isArray(previous) ? { ...previous } : {};
    state[HISTORY_KEY] = { kind, listContext, enteredFromList };
    return state;
  }

  function setView(content, view) {
    const insider = content.querySelector('[data-member-lab-insider]');
    const listView = content.querySelector('[data-member-lab-insider-list]');
    const articleView = content.querySelector('[data-member-lab-insider-article]');
    const detail = content.querySelector('[data-member-lab-insider-detail]');
    const articleStatus = content.querySelector('[data-member-lab-insider-article-status]');
    if (!insider || !listView || !articleView || !detail || !articleStatus) return;
    insider.dataset.insiderView = view;
    listView.hidden = view !== 'LIST';
    articleView.hidden = view === 'LIST';
    articleStatus.hidden = view === 'LIST' || view === 'ARTICLE';
    detail.hidden = view !== 'ARTICLE';
  }

  function articleStatus(content, message) {
    const node = content.querySelector('[data-member-lab-insider-article-status]');
    if (node) node.textContent = message;
  }

  function restoreList(content, listContext) {
    const insider = content.querySelector('[data-member-lab-insider]');
    if (insider && listContext) insider.dataset.insiderExpanded = listContext.expanded ? 'true' : 'false';
    if (window.MemberLabUxRuntime) window.MemberLabUxRuntime.applyInsiderView(content);
    const heading = content.querySelector('[data-member-lab-insider-list-heading]');
    window.requestAnimationFrame(function () {
      const links = content.querySelectorAll('[data-member-lab-insider-link]');
      const opener = listContext && Array.from(links).find(function (link) { return link.dataset.insiderHandle === listContext.handle; });
      if (opener) opener.focus({ preventScroll: true });
      else if (heading) {
        heading.tabIndex = -1;
        heading.focus({ preventScroll: true });
      }
      if (listContext && Number.isFinite(listContext.scrollY)) window.scrollTo(0, listContext.scrollY);
      else if (heading) heading.scrollIntoView({ block: 'start' });
    });
  }

  function showList(content, listContext, restore) {
    content._memberLabInsiderRequest = (content._memberLabInsiderRequest || 0) + 1;
    cleanupArticleFrameAutoHeight(content);
    setView(content, 'LIST');
    if (restore) restoreList(content, listContext);
  }

  function renderDetail(content, post) {
    const detail = content.querySelector('[data-member-lab-insider-detail]');
    if (!detail) return;
    cleanupArticleFrameAutoHeight(content);
    detail.replaceChildren();
    const title = document.createElement('h2');
    title.textContent = post.title;
    title.tabIndex = -1;
    const date = document.createElement('p');
    date.className = 'fh-member-lab__insider-date';
    date.textContent = formatDate(post.updatedAt || post.createdAt);
    const frame = document.createElement('iframe');
    frame.className = 'fh-member-lab__insider-body';
    frame.setAttribute('sandbox', 'allow-same-origin');
    frame.setAttribute('referrerpolicy', 'no-referrer');
    frame.setAttribute('scrolling', 'no');
    frame.title = post.title;
    frame.srcdoc = safeArticleDocument(post.bodyHtml, post.bodySafeHtml);
    detail.append(title, date);
    const image = imageFor(post);
    if (image) detail.appendChild(image);
    detail.appendChild(frame);
    content._memberLabInsiderFrameCleanup = setupArticleFrameAutoHeight(frame);
    setView(content, 'ARTICLE');
    title.focus({ preventScroll: true });
    const articleView = content.querySelector('[data-member-lab-insider-article]');
    if (articleView) articleView.scrollIntoView({ block: 'start' });
  }

  async function showArticle(content, handle) {
    const request = (content._memberLabInsiderRequest || 0) + 1;
    content._memberLabInsiderRequest = request;
    const articleView = content.querySelector('[data-member-lab-insider-article]');
    cleanupArticleFrameAutoHeight(content);
    articleStatus(content, copy(content, 'insiderLoading', 'Loading FunnyHooks Insider…'));
    setView(content, 'LOADING');
    if (articleView) articleView.scrollIntoView({ block: 'start' });
    try {
      if (typeof handle !== 'string' || !HANDLE.test(handle)) throw new Error('invalid_member_news_handle');
      const payload = await getJson(`${API_PATH}/${encodeURIComponent(handle)}`);
      if (request !== content._memberLabInsiderRequest) return;
      if (!validDetail(payload) || payload.post.handle !== handle) throw new Error('invalid_member_news_response');
      renderDetail(content, payload.post);
    } catch {
      if (request !== content._memberLabInsiderRequest) return;
      articleStatus(content, copy(content, 'insiderError', 'FunnyHooks Insider is temporarily unavailable. Please try again later.'));
      setView(content, 'ERROR');
      const error = content.querySelector('[data-member-lab-insider-article-status]');
      if (error) error.focus({ preventScroll: true });
    }
  }

  function openArticle(content, handle) {
    const insider = content.querySelector('[data-member-lab-insider]');
    const listContext = {
      handle,
      expanded: Boolean(insider && insider.dataset.insiderExpanded === 'true'),
      scrollY: window.scrollY,
    };
    content._memberLabInsiderListContext = listContext;
    window.history.replaceState(historyState('LIST', listContext, false), '', pageUrl(null));
    window.history.pushState(historyState('ARTICLE', listContext, true), '', pageUrl(handle));
    showArticle(content, handle);
  }

  function backToList(content) {
    const state = window.history.state && window.history.state[HISTORY_KEY];
    if (state && state.kind === 'ARTICLE' && state.enteredFromList) {
      window.history.back();
      return;
    }
    const listContext = content._memberLabInsiderListContext || null;
    window.history.pushState(historyState('LIST', listContext, false), '', pageUrl(null));
    showList(content, listContext, true);
  }

  function appendPost(content, list, post) {
    if (content._memberLabInsiderHandles.has(post.handle)) return;
    content._memberLabInsiderHandles.add(post.handle);
    const card = document.createElement('article');
    card.className = 'fh-member-lab__insider-card';
    const image = imageFor(post);
    if (image) card.appendChild(image);
    const title = document.createElement('h3');
    title.textContent = post.title;
    const date = document.createElement('p');
    date.className = 'fh-member-lab__insider-date';
    date.textContent = formatDate(post.updatedAt || post.createdAt);
    const action = document.createElement('a');
    action.className = 'button button--secondary';
    action.tabIndex = 0;
    action.href = pageUrl(post.handle);
    action.dataset.insiderHandle = post.handle;
    action.setAttribute('data-member-lab-insider-link', '');
    action.textContent = copy(content, 'insiderReadMore', 'Read more');
    action.setAttribute('aria-label', `${action.textContent}: ${post.title}`);
    action.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      openArticle(content, post.handle);
    });
    card.append(title, date, action);
    list.appendChild(card);
  }

  function renderList(content, posts, nextCursor, append) {
    const list = content.querySelector('[data-member-lab-insider-posts]');
    const more = content.querySelector('[data-member-lab-insider-more]');
    if (!list) return;
    if (!append) {
      list.replaceChildren();
      content._memberLabInsiderHandles = new Set();
    }
    posts.forEach(function (post) { appendPost(content, list, post); });
    content._memberLabInsiderNextCursor = nextCursor;
    if (more) {
      more.hidden = nextCursor === null;
      more.disabled = false;
    }
    if (list.children.length === 0 && nextCursor === null) {
      status(content, copy(content, 'insiderEmpty', 'No news yet. Please check back soon.'));
      return;
    }
    status(content, '');
  }

  async function initialize(content) {
    if (!canInitialize(content) || content.dataset.memberLabInsiderInitialized === 'true') return;
    content.dataset.memberLabInsiderInitialized = 'true';
    const requested = articleHandle();
    if (requested !== null) {
      articleStatus(content, copy(content, 'insiderLoading', 'Loading FunnyHooks Insider…'));
      setView(content, 'LOADING');
    }
    status(content, copy(content, 'insiderLoading', 'Loading FunnyHooks Insider…'));
    try {
      const payload = await getJson(API_PATH);
      if (!validList(payload)) throw new Error('invalid_member_news_response');
      renderList(content, payload.posts, payload.nextCursor, false);
    } catch {
      status(content, copy(content, 'insiderError', 'FunnyHooks Insider is temporarily unavailable. Please try again later.'));
    }
    if (requested !== null) showArticle(content, requested);
  }

  async function loadMore(content) {
    const cursor = content._memberLabInsiderNextCursor;
    const more = content.querySelector('[data-member-lab-insider-more]');
    if (!canInitialize(content) || typeof cursor !== 'string' || !CURSOR.test(cursor) || content._memberLabInsiderLoadingMore) return;
    content._memberLabInsiderLoadingMore = true;
    if (more) more.disabled = true;
    status(content, copy(content, 'insiderLoading', 'Loading FunnyHooks Insider…'));
    try {
      const payload = await getJson(`${API_PATH}?cursor=${encodeURIComponent(cursor)}`);
      if (!validList(payload)) throw new Error('invalid_member_news_response');
      renderList(content, payload.posts, payload.nextCursor, true);
    } catch {
      if (more) more.disabled = false;
      status(content, copy(content, 'insiderError', 'FunnyHooks Insider is temporarily unavailable. Please try again later.'));
    } finally {
      content._memberLabInsiderLoadingMore = false;
    }
  }

  function canInitialize(content) {
    const gate = content.closest && content.closest('[data-member-lab-gate]');
    return Boolean(gate && gate.dataset.memberLabResolved === 'ENTITLED' && content.hidden === false);
  }

  function initializeReadyContent() {
    document.querySelectorAll('[data-member-lab-content]').forEach(function (content) {
      if (canInitialize(content)) initialize(content);
    });
  }

  document.addEventListener('member-lab-content-ready', function (event) {
    if (event.detail && canInitialize(event.detail)) initialize(event.detail);
  });
  document.addEventListener('click', function (event) {
    const back = event.target && event.target.closest && event.target.closest('[data-member-lab-insider-back]');
    if (back) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const content = back.closest('[data-member-lab-content]');
      if (content && canInitialize(content)) {
        event.preventDefault();
        backToList(content);
      }
      return;
    }
    const button = event.target && event.target.closest && event.target.closest('[data-member-lab-insider-more]');
    if (!button) return;
    const content = button.closest('[data-member-lab-content]');
    if (content) loadMore(content);
  });
  window.addEventListener('popstate', function (event) {
    document.querySelectorAll('[data-member-lab-content]').forEach(function (content) {
      if (!canInitialize(content) || content.dataset.memberLabInsiderInitialized !== 'true') return;
      const state = event.state && event.state[HISTORY_KEY];
      const listContext = state && state.listContext || content._memberLabInsiderListContext || null;
      if (listContext) content._memberLabInsiderListContext = listContext;
      const requested = articleHandle();
      if (requested === null) showList(content, listContext, true);
      else showArticle(content, requested);
    });
  });
  initializeReadyContent();

  window.MemberLabInsiderRuntime = { validPost, validList, validDetail, safeArticleDocument, initialize, canInitialize, loadMore };
})();
